import React, { useState, useEffect, useContext } from 'react'

import LoadingContext from '../../context/Loading/Loading'
import AuthService from '../../utilities/services/auth.service'

import { getMyOrganizations, updateOrgDetails } from '../../utilities/api'

import Form from 'react-bootstrap/Form'
import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

import { OrganizationInformationWrapper } from '../OrganizationInformationWrapper'
import { Spinner } from '../LoadingContainer/Spinner'
import { PageLoadingContainer } from '../PageLoadingContainer'

// Settings Organization Information page
export default function OrganizationInfoWrapper() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)

  const { isAccountOwner, isAdmin, isSuperAdminOrganizer } = AuthService

  const canEditOptInMessage = () =>
    isAccountOwner() || isAdmin() || isSuperAdminOrganizer()

  const [orgInfo, setOrgInfo] = useState()

  const [initialState, setInitialState] = useState()

  const [alert, setAlert] = useState({
    show: false,
    variant: '',
    message: '',
  })

  const [isDisabled, setIsDisabled] = useState(true)

  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    showLoading()
    const activeOrg = AuthService.getOrg()?.[0]
    getMyOrganizations()
      .then((res) => {
        const list = res?.data || []
        const matched = activeOrg?.uuid
          ? list.find((o) => o.uuid === activeOrg.uuid)
          : null
        const row = matched ?? activeOrg ?? list[0]
        setOrgInfo(row)
        setInitialState(row)
        hideLoading()
      })
      .catch(() => {
        hideLoading()
      })
  }, [])

  // enable save button when data has been loaded and object has changed
  useEffect(() => {
    if (
      initialState?.name !== orgInfo?.name ||
      initialState?.address !== orgInfo?.address ||
      (initialState?.opt_in_message || '') !== (orgInfo?.opt_in_message || '')
    ) {
      setIsDisabled(false)
    } else setIsDisabled(true)
  }, [initialState, orgInfo])

  const handleSave = (e) => {
    e.preventDefault()
    if (!canEditOptInMessage() || isDisabled) return
    setIsSaving(true)
    updateOrgDetails(orgInfo)
      .then((res) => {
        setAlert({
          show: true,
          variant: 'success',
          message: 'Your info has been updated.',
        })
        setIsSaving(false)
        // save initial state to check whether to disable button
        // setInitialState(res.data)
        setIsDisabled(true)
      })
      .catch((err) => {
        setIsSaving(false)
        console.error(err)
        setAlert({
          show: true,
          variant: 'danger',
          message: 'Unable to save info please try again.',
        })
      })
  }

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <div className="position-relative">
          <section className={`wrapper`}>
            {alert.show && (
              <>
                <Alert
                  variant={alert.variant}
                  className="mb-5"
                  onClose={() =>
                    setAlert({ show: false, variant: '', message: '' })
                  }
                  dismissible
                >
                  {alert.message}
                </Alert>
              </>
            )}
            <header className="section-header">
              <div className="section-heading section-heading--secondary">
                <h1>Organization info</h1>
              </div>
              <p className="section-header-desc">
                Details that apply across your events and billing
              </p>
            </header>
            <Form data-testid="organization-info-form" onSubmit={handleSave}>
              <Card body className="card--sm">
                <OrganizationInformationWrapper
                  getOrgInfo={setOrgInfo}
                  orgInfo={orgInfo}
                  isReadOnly={!isAccountOwner()}
                />
              </Card>
              <Card body className="card--sm mt-4">
                <h2 className="h5 mb-3">Opt in message</h2>
                <p className="section-header-desc mb-3">
                  Custom checkbox text shown at checkout when buyers opt in to
                  emails. Leave blank to use the default message.
                </p>
                <Form.Group
                  className="form-group mb-0"
                  controlId="opt_in_message"
                >
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="opt_in_message"
                    readOnly={!canEditOptInMessage()}
                    data-testid="organization-info-opt-in-message"
                    placeholder={
                      orgInfo?.name
                        ? `Send me emails from ${orgInfo.name} about upcoming events and offers.`
                        : 'Send me emails about upcoming events and offers.'
                    }
                    value={orgInfo?.opt_in_message || ''}
                    onChange={(e) =>
                      setOrgInfo((prev) => ({
                        ...prev,
                        opt_in_message: e.target.value,
                      }))
                    }
                  />
                </Form.Group>
              </Card>
              <Stack direction="horizontal" className="btn-group-flex">
                <Button
                  type="submit"
                  size="lg"
                  className="btn-width-sm"
                  data-testid="organization-info-save"
                  disabled={!canEditOptInMessage() || isDisabled || isSaving}
                >
                  {isSaving ? <Spinner /> : 'Save'}
                </Button>
              </Stack>
            </Form>
          </section>
        </div>
      )}
    </>
  )
}
